import { useNavigate } from "react-router";
import useTranslation from "utils/hooks/useTranslation";
import Button from "./shared/button";
import { getAppUrl } from "utils/defines";
import { useProject } from "utils/hooks/useProject";

interface NewProjectWidgetProps {
    onBeforeClick?: (callback: any) => void;
}

const NewProjectWidget: React.FC<NewProjectWidgetProps> = ({onBeforeClick}) => {
  const { tText } = useTranslation();
  const navigate = useNavigate();
  const { initNewProject } = useProject();

  return <>
    <group data-gap="30">
      <Button
        secondary
        large
        fit
        text={tText("HOME_NEW_PROJECT")}
        icon="note_add"
        onClick={() => {
          if (onBeforeClick != null) {
            onBeforeClick(()=>{
              initNewProject()
              navigate(getAppUrl('/project/home/heat'))
            })
          } else {
            initNewProject()
            navigate(getAppUrl('/project/home/heat'))
          }
        }}
      >
        {/* <icon>note_add</icon> */}
      </Button>
    </group>
  </>
}



export default NewProjectWidget;